module.exports = __webpack_public_path__ + "img/ar16.33ff10b2.jpg";